import { Controller } from '@hotwired/stimulus';
import { eventListener } from '@inked/utilities';

export class FieldController extends Controller {
  static targets = ['control'];
  static values = {
    dirty: {
      default: false,
      type: Boolean,
    },
    touched: {
      default: false,
      type: Boolean,
    },
  };

  connect() {
    this.initialValue = this.getValue(this.controlTarget);

    this.stopControlEvent = eventListener(
      this.controlTarget,
      [ 'change', 'input' ],
      event => {
        if (this.type === 'radio') {
          [...document.querySelectorAll(`[name="${this.controlTarget.name}"]`)]
            .filter(control => !control.isSameNode(this.controlTarget))
            .forEach(control => control.dispatchEvent(new Event('sync')));
        }

        this.dirtyValue = this.getValue(event.target) !== this.initialValue;
        this.touchedValue = true;

        this.dispatch('update', {
          detail: {
            element: this.element,
            state: this.state,
          },
        });
      },
    );
    this.stopSyncEvent = eventListener(
      this.controlTarget,
      'sync',
      event => {
        this.dirtyValue = this.getValue(event.target) !== this.initialValue;

        this.dispatch('sync', {
          detail: {
            element: this.element,
            state: this.state,
          },
        });
      },
    );
  }

  disconnect() {
    if (this.stopControlEvent) this.stopControlEvent();
    if (this.stopSyncEvent) this.stopSyncEvent();
  }

  getValue(element) {
    switch (this.type) {
      case 'checkbox':
      case 'radio':
        return element.checked;
      case 'select':
        if (element.multiple) return Array.from(element.selectedOptions).map(option => option.value);

        return element.value;
      case 'input':
      case 'textarea':
      default:
        return element.value;
    }
  }

  get state() {
    return {
      dirty: this.dirtyValue,
      touched: this.touchedValue,
    };
  }

  get type() {
    const tag = this.controlTarget.tagName.toLowerCase();

    if (
      tag === 'input'
      && [ 'checkbox', 'radio' ].includes(this.controlTarget.type)
    ) return this.controlTarget.type;

    return tag;
  }
}
